module.exports = __webpack_public_path__ + "Roboto-Bold.ee7b96fa85d8fdb8c126.ttf";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/fonts/Roboto-Bold.ttf
// module id = ../../../../../src/assets/fonts/Roboto-Bold.ttf
// module chunks = main